/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DeviceFragment = {
	id: string;
	status: Types.DeviceStatus;
	virtual: boolean;
	isDeviceNode: 'Device';
	description: {
		model: string;
		features: {
			ethernetLights: { supported: boolean };
			lightingBrightness: { supported: boolean };
			lightingMuteBehavior: { supported: boolean };
			lightingUnmuteBehavior: { supported: boolean };
			audioMute: { supported: boolean };
			errorIndicator: { supported: boolean };
			lightingBehavior: { supported: boolean };
			identify: { supported: boolean };
			lightingRing: { supported: boolean };
			lightingSegmentsBehavior: { supported: boolean };
			lightingAutomixGating: { supported: boolean };
			audioMuteControl: { supported: boolean };
			transmitterLightingBehavior: { supported: boolean };
			configurationLock: { supported: boolean };
			linkButtonLock: { supported: boolean };
			conferencingOperationMode: { supported: boolean };
			chargerBays: { supported: boolean };
			lightingAudioActivity: { supported: boolean };
			transmitterMuteBehavior: { supported: boolean };
		};
		constraints: {
			lightingBrightness: { level: { range: { max: number; min: number; step: number } } } | null;
			lightingMuteBehavior: {
				color: { options: Array<Types.LightingColor> };
				mode: { options: Array<Types.LightingMode> };
			} | null;
			lightingUnmuteBehavior: {
				color: { options: Array<Types.LightingColor> };
				mode: { options: Array<Types.LightingMode> };
			} | null;
			lightingAutomixGating: {
				automixerInputDisengagedBehavior: { options: Array<Types.AutomixerInputDisengagedBehavior> } | null;
			} | null;
			lightingRing: { style: { options: Array<Types.LightingStyle> } } | null;
			transmitterLightingBehavior: {
				behavior: { options: Array<Types.TransmitterLightingBehavior> } | null;
			} | null;
		};
	};
	features: {
		audioChannels: { audioChannels: Array<LightsAudioChannelFragment> } | null;
		name: { name: string } | null;
		ethernetLights: { enabled: boolean } | null;
		errorIndicator: { state: Types.ErrorIndicator } | null;
		lightingBrightness: { supportedLevels: number; level: number } | null;
		lightingMuteBehavior: { mode: Types.LightingMode; color: Types.LightingColor } | null;
		lightingUnmuteBehavior: { mode: Types.LightingMode; color: Types.LightingColor } | null;
		audioMute: { muted: boolean } | null;
		lightingBehavior: {
			color: Types.LightingColor | null;
			mode: Types.LightingMode | null;
			state: Types.LightingState | null;
		} | null;
		identify: { identifying: boolean } | null;
		lightingRing: { style: Types.LightingStyle } | null;
		lightingSegmentsBehavior: {
			segments: Array<{ mode: Types.LightingSegmentMode; color: { blue: number; green: number; red: number } }>;
		} | null;
		lightingAutomixGating: {
			automixerInputDisengagedBehavior: Types.AutomixerInputDisengagedBehavior;
			enabled: boolean;
		} | null;
		authentication: {
			credentials: Array<{ accessLevel: string; credentialsState: Types.CredentialsState }> | null;
		} | null;
		audioMuteControl: { function: Types.MuteControlFunction } | null;
		transmitterLightingBehavior: { behavior: Types.TransmitterLightingBehavior } | null;
		configurationLock: { enabled: boolean } | null;
		linkButtonLock: { enabled: boolean } | null;
		conferencingOperationMode: { mode: Types.ConferencingOperationMode } | null;
		chargerBays: {
			chargerBays: Array<{ id: string; features: { dockedDevice: { device: { id: string } | null } | null } }>;
		} | null;
		lightingAudioActivity: { enabled: boolean } | null;
		transmitterMuteBehavior: { muteBehavior: Types.TransmitterMuteBehavior } | null;
	};
};

export type LightsAudioChannelFragment = {
	id: string;
	isChannelNode: 'AudioChannel';
	features: {
		lobeConfiguration: { enabled: boolean } | null;
		micPolarPattern: { pattern: Types.MicPolarPattern } | null;
		microphoneAngle?: { fixed: { angle: number } } | null;
		mute: { muted: boolean } | null;
		identify: { identifying: boolean } | null;
		lightingBehavior: {
			color: Types.LightingColor | null;
			mode: Types.LightingMode | null;
			state: Types.LightingState | null;
		} | null;
		automixer: { enabled: boolean | null } | null;
		carriedByRfChannels: { rfChannels: Array<LightsDeviceRfChannelFragment> } | null;
	};
	description: {
		groupName: string;
		features: {
			lobeConfiguration: { supported: boolean };
			micPolarPattern: { supported: boolean };
			microphoneAngle?: { supported: boolean };
			mute: { supported: boolean };
			identify: { supported: boolean };
			lightingBehavior: { supported: boolean };
			automixer: { supported: boolean };
			carriedByRfChannels: { supported: boolean };
		};
	};
};

export type LightsDeviceRfChannelFragment = {
	id: string;
	description: { features: { linkedTransmitter: { supported: boolean } } };
	features: {
		linkedTransmitter: {
			linkage: {
				device: {
					id: string;
					status: Types.DeviceStatus;
					features: { micStatusV2: { status: Types.MicStatusV2 } | null };
				} | null;
			} | null;
		} | null;
	};
};

export type DeviceUpdateFragment = {
	id: string;
	features:
		| { audioMute: { muted: boolean } | null }
		| { audioMuteControl: { function: Types.MuteControlFunction } | null }
		| {
				authentication: {
					credentials: Array<{ accessLevel: string; credentialsState: Types.CredentialsState }> | null;
				} | null;
		  }
		| { conferencingOperationMode: { mode: Types.ConferencingOperationMode } | null }
		| { errorIndicator: { state: Types.ErrorIndicator } | null }
		| { ethernetLights: { enabled: boolean } | null }
		| { identify: { identifying: boolean } | null }
		| { lightingAudioActivity: { enabled: boolean } | null }
		| {
				lightingAutomixGating: {
					automixerInputDisengagedBehavior: Types.AutomixerInputDisengagedBehavior;
					enabled: boolean;
				} | null;
		  }
		| {
				lightingBehavior: {
					color: Types.LightingColor | null;
					mode: Types.LightingMode | null;
					state: Types.LightingState | null;
				} | null;
		  }
		| { lightingBrightness: { supportedLevels: number; level: number } | null }
		| { lightingMuteBehavior: { mode: Types.LightingMode; color: Types.LightingColor } | null }
		| { lightingRing: { style: Types.LightingStyle } | null }
		| {
				lightingSegmentsBehavior: {
					segments: Array<{
						mode: Types.LightingSegmentMode;
						color: { blue: number; green: number; red: number };
					}>;
				} | null;
		  }
		| { lightingUnmuteBehavior: { mode: Types.LightingMode; color: Types.LightingColor } | null }
		| { name: { name: string } | null }
		| { transmitterLightingBehavior: { behavior: Types.TransmitterLightingBehavior } | null }
		| { transmitterMuteBehavior: { muteBehavior: Types.TransmitterMuteBehavior } | null }
		| {};
};

export type LightsAudioChannelChangeFragment = {
	id: string;
	features:
		| { identify: { identifying: boolean } | null }
		| {
				lightingBehavior: {
					color: Types.LightingColor | null;
					mode: Types.LightingMode | null;
					state: Types.LightingState | null;
				} | null;
		  }
		| { lobeConfiguration: { enabled: boolean } | null }
		| { micPolarPattern: { pattern: Types.MicPolarPattern } | null }
		| { microphoneAngle: { fixed: { angle: number } } | null }
		| { mute: { muted: boolean } | null }
		| {};
};

export type GetDeviceQueryVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	excludeMicrophoneAngle: Types.Scalars['Boolean']['input'];
}>;

export type GetDeviceQueryOpResult = { node: DeviceFragment | {} };

export type UpdateDeviceMutationVariables = Types.Exact<{
	updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
	excludeMicrophoneAngle: Types.Scalars['Boolean']['input'];
}>;

export type UpdateDeviceMutationOpResult = {
	updateNodes: Array<
		{ device: DeviceFragment | null; error: { code: Types.ErrorCode; message: string } | null } | {}
	>;
};

export type ClearErrorIndicatorMutationVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type ClearErrorIndicatorMutationOpResult = {
	clearErrorIndicator: { device: { id: string } | null; error: { code: Types.ErrorCode; message: string } | null };
};

export type LightsSettingsDeviceSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
	excludeMicrophoneAngle: Types.Scalars['Boolean']['input'];
}>;

export type LightsSettingsDeviceSubscriptionOpResult = { nodeChanges: DeviceFragment | DeviceUpdateFragment | {} };

export type LightSettingsChannelsSubscriptionVariables = Types.Exact<{
	id: Types.Scalars['ID']['input'];
	types: Array<Types.NodeChangeType> | Types.NodeChangeType;
	excludeMicrophoneAngle: Types.Scalars['Boolean']['input'];
}>;

export type LightSettingsChannelsSubscriptionOpResult = {
	nodeChanges: LightsAudioChannelFragment | LightsAudioChannelChangeFragment | {};
};

export type UpdateDeviceLightingBrightnessMutationVariables = Types.Exact<{
	input: Types.DeviceLightingBrightnessUpdateInput;
	injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type UpdateDeviceLightingBrightnessMutationOpResult = {
	updateDeviceLightingBrightness: { device: { features: { lightingBrightness: { level: number } | null } } | null };
};

export const LightsDeviceRfChannelFragment = gql`
	fragment LightsDeviceRfChannelFragment on RfChannel {
		id
		description {
			features {
				linkedTransmitter {
					supported
				}
			}
		}
		features {
			linkedTransmitter {
				linkage {
					device {
						id
						status
						features {
							micStatusV2 {
								status
							}
						}
					}
				}
			}
		}
	}
`;
export const LightsAudioChannelFragment = gql`
	fragment LightsAudioChannelFragment on AudioChannel {
		isChannelNode: __typename
		id
		features {
			lobeConfiguration {
				enabled
			}
			micPolarPattern {
				pattern
			}
			microphoneAngle @skip(if: $excludeMicrophoneAngle) {
				fixed {
					angle
				}
			}
			mute {
				muted
			}
			identify {
				identifying
			}
			lightingBehavior {
				color
				mode
				state
			}
			automixer {
				enabled
			}
			carriedByRfChannels {
				rfChannels {
					...LightsDeviceRfChannelFragment
				}
			}
		}
		description {
			groupName
			features {
				lobeConfiguration {
					supported
				}
				micPolarPattern {
					supported
				}
				microphoneAngle @skip(if: $excludeMicrophoneAngle) {
					supported
				}
				mute {
					supported
				}
				identify {
					supported
				}
				lightingBehavior {
					supported
				}
				automixer {
					supported
				}
				carriedByRfChannels {
					supported
				}
			}
		}
	}
	${LightsDeviceRfChannelFragment}
`;
export const DeviceFragment = gql`
	fragment DeviceFragment on Device {
		isDeviceNode: __typename
		id
		status
		virtual
		description {
			model
			features {
				ethernetLights {
					supported
				}
				lightingBrightness {
					supported
				}
				lightingMuteBehavior {
					supported
				}
				lightingUnmuteBehavior {
					supported
				}
				audioMute {
					supported
				}
				errorIndicator {
					supported
				}
				lightingBehavior {
					supported
				}
				identify {
					supported
				}
				lightingRing {
					supported
				}
				lightingSegmentsBehavior {
					supported
				}
				lightingAutomixGating {
					supported
				}
				audioMuteControl {
					supported
				}
				transmitterLightingBehavior {
					supported
				}
				configurationLock {
					supported
				}
				linkButtonLock {
					supported
				}
				conferencingOperationMode {
					supported
				}
				chargerBays {
					supported
				}
				lightingAudioActivity {
					supported
				}
				transmitterMuteBehavior {
					supported
				}
			}
			constraints {
				lightingBrightness {
					level {
						range {
							max
							min
							step
						}
					}
				}
				lightingMuteBehavior {
					color {
						options
					}
					mode {
						options
					}
				}
				lightingUnmuteBehavior {
					color {
						options
					}
					mode {
						options
					}
				}
				lightingAutomixGating {
					automixerInputDisengagedBehavior {
						options
					}
				}
				lightingRing {
					style {
						options
					}
				}
				transmitterLightingBehavior {
					behavior {
						options
					}
				}
			}
		}
		features {
			audioChannels {
				audioChannels {
					...LightsAudioChannelFragment
				}
			}
			name {
				name
			}
			ethernetLights {
				enabled
			}
			errorIndicator {
				state
			}
			lightingBrightness {
				supportedLevels
				level
			}
			lightingMuteBehavior {
				mode
				color
			}
			lightingUnmuteBehavior {
				mode
				color
			}
			audioMute {
				muted
			}
			lightingBehavior {
				color
				mode
				state
			}
			identify {
				identifying
			}
			lightingRing {
				style
			}
			lightingSegmentsBehavior {
				segments {
					mode
					color {
						blue
						green
						red
					}
				}
			}
			lightingAutomixGating {
				automixerInputDisengagedBehavior
				enabled
			}
			authentication {
				credentials {
					accessLevel
					credentialsState
				}
			}
			audioMuteControl {
				function
			}
			transmitterLightingBehavior {
				behavior
			}
			configurationLock {
				enabled
			}
			linkButtonLock {
				enabled
			}
			conferencingOperationMode {
				mode
			}
			chargerBays {
				chargerBays {
					id
					features {
						dockedDevice {
							device {
								id
							}
						}
					}
				}
			}
			lightingAudioActivity {
				enabled
			}
			transmitterMuteBehavior {
				muteBehavior
			}
		}
	}
	${LightsAudioChannelFragment}
`;
export const DeviceUpdateFragment = gql`
	fragment DeviceUpdateFragment on DeviceChange {
		id
		features {
			... on DeviceNameChange {
				name {
					name
				}
			}
			... on DeviceEthernetLightsChange {
				ethernetLights {
					enabled
				}
			}
			... on DeviceErrorIndicatorChange {
				errorIndicator {
					state
				}
			}
			... on DeviceLightingUnmuteBehaviorChange {
				lightingUnmuteBehavior {
					mode
					color
				}
			}
			... on DeviceLightingMuteBehaviorChange {
				lightingMuteBehavior {
					mode
					color
				}
			}
			... on DeviceLightingBrightnessChange {
				lightingBrightness {
					supportedLevels
					level
				}
			}
			... on DeviceAudioMuteChange {
				audioMute {
					muted
				}
			}
			... on DeviceLightingBehaviorChange {
				lightingBehavior {
					color
					mode
					state
				}
			}
			... on DeviceIdentifyChange {
				identify {
					identifying
				}
			}
			... on DeviceLightingRingChange {
				lightingRing {
					style
				}
			}
			... on DeviceLightingSegmentsBehaviorChange {
				lightingSegmentsBehavior {
					segments {
						mode
						color {
							blue
							green
							red
						}
					}
				}
			}
			... on DeviceLightingAutomixGatingChange {
				lightingAutomixGating {
					automixerInputDisengagedBehavior
					enabled
				}
			}
			... on DeviceAuthenticationChange {
				authentication {
					credentials {
						accessLevel
						credentialsState
					}
				}
			}
			... on DeviceAudioMuteControlChange {
				audioMuteControl {
					function
				}
			}
			... on DeviceTransmitterLightingBehaviorChange {
				transmitterLightingBehavior {
					behavior
				}
			}
			... on DeviceConferencingOperationModeChange {
				conferencingOperationMode {
					mode
				}
			}
			... on DeviceLightingAudioActivityChange {
				lightingAudioActivity {
					enabled
				}
			}
			... on DeviceTransmitterMuteBehaviorChange {
				transmitterMuteBehavior {
					muteBehavior
				}
			}
		}
	}
`;
export const LightsAudioChannelChangeFragment = gql`
	fragment LightsAudioChannelChangeFragment on AudioChannelChange {
		id
		features {
			... on AudioChannelMicrophoneAngleChange @skip(if: $excludeMicrophoneAngle) {
				microphoneAngle {
					fixed {
						angle
					}
				}
			}
			... on AudioChannelLobeConfigurationChange {
				lobeConfiguration {
					enabled
				}
			}
			... on AudioChannelMicPolarPatternChange {
				micPolarPattern {
					pattern
				}
			}
			... on AudioChannelMuteChange {
				mute {
					muted
				}
			}
			... on AudioChannelIdentifyChange {
				identify {
					identifying
				}
			}
			... on AudioChannelLightingBehaviorChange {
				lightingBehavior {
					color
					mode
					state
				}
			}
		}
	}
`;
export const GetDeviceQueryDocument = gql`
	query GetDeviceQuery($id: ID!, $excludeMicrophoneAngle: Boolean!) {
		node(id: $id) {
			...DeviceFragment
		}
	}
	${DeviceFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class GetDeviceQueryGQL extends Apollo.Query<GetDeviceQueryOpResult, GetDeviceQueryVariables> {
	override document = GetDeviceQueryDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const UpdateDeviceMutationDocument = gql`
	mutation UpdateDeviceMutation(
		$updates: [NodeUpdateInput!]!
		$injectKeyring: String
		$excludeMicrophoneAngle: Boolean!
	) {
		updateNodes(updates: $updates, keyring: $injectKeyring) {
			... on DeviceOperationResult {
				device {
					...DeviceFragment
				}
				error {
					code
					message
				}
			}
		}
	}
	${DeviceFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class UpdateDeviceMutationGQL extends Apollo.Mutation<
	UpdateDeviceMutationOpResult,
	UpdateDeviceMutationVariables
> {
	override document = UpdateDeviceMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const ClearErrorIndicatorMutationDocument = gql`
	mutation ClearErrorIndicatorMutation($id: ID!, $injectKeyring: String) {
		clearErrorIndicator(id: $id, keyring: $injectKeyring) {
			... on DeviceOperationResult {
				device {
					id
				}
				error {
					code
					message
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class ClearErrorIndicatorMutationGQL extends Apollo.Mutation<
	ClearErrorIndicatorMutationOpResult,
	ClearErrorIndicatorMutationVariables
> {
	override document = ClearErrorIndicatorMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const LightsSettingsDeviceSubscriptionDocument = gql`
	subscription LightsSettingsDeviceSubscription(
		$id: ID!
		$types: [NodeChangeType!]!
		$excludeMicrophoneAngle: Boolean!
	) {
		nodeChanges(id: $id, types: $types) {
			...DeviceFragment
			...DeviceUpdateFragment
		}
	}
	${DeviceFragment}
	${DeviceUpdateFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class LightsSettingsDeviceSubscriptionGQL extends Apollo.Subscription<
	LightsSettingsDeviceSubscriptionOpResult,
	LightsSettingsDeviceSubscriptionVariables
> {
	override document = LightsSettingsDeviceSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const LightSettingsChannelsSubscriptionDocument = gql`
	subscription LightSettingsChannelsSubscription(
		$id: ID!
		$types: [NodeChangeType!]!
		$excludeMicrophoneAngle: Boolean!
	) {
		nodeChanges(id: $id, types: $types) {
			...LightsAudioChannelFragment
			...LightsAudioChannelChangeFragment
		}
	}
	${LightsAudioChannelFragment}
	${LightsAudioChannelChangeFragment}
`;

@Injectable({
	providedIn: 'root'
})
export class LightSettingsChannelsSubscriptionGQL extends Apollo.Subscription<
	LightSettingsChannelsSubscriptionOpResult,
	LightSettingsChannelsSubscriptionVariables
> {
	override document = LightSettingsChannelsSubscriptionDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
export const UpdateDeviceLightingBrightnessMutationDocument = gql`
	mutation UpdateDeviceLightingBrightnessMutation(
		$input: DeviceLightingBrightnessUpdateInput!
		$injectKeyring: String
	) {
		updateDeviceLightingBrightness(input: $input, keyring: $injectKeyring) {
			device {
				features {
					lightingBrightness {
						level
					}
				}
			}
		}
	}
`;

@Injectable({
	providedIn: 'root'
})
export class UpdateDeviceLightingBrightnessMutationGQL extends Apollo.Mutation<
	UpdateDeviceLightingBrightnessMutationOpResult,
	UpdateDeviceLightingBrightnessMutationVariables
> {
	override document = UpdateDeviceLightingBrightnessMutationDocument;
	override client = 'sysApi';
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
